import axios from 'axios'
import { BACKEND_URL } from '../config'
import router from '../router'

const authorizationHeader = () => 'Token ' + getCookie('auth_key')

export function get(url) {
  const config = jsonConfig()
  config['method'] = 'get'
  config['url'] = url
  return run(config)
}

export function post(url, data) {
  const config = jsonConfig()
  config['method'] = 'post'
  config['url'] = url
  config['data'] = data
  return run(config)
}

const jsonConfig = () => {
  return {
    headers: {
      'Content-Type': 'application/json',
      Authorization: authorizationHeader()
    }
  }
}

function run(config) {
  return axios(config).catch(error => {
    return handleBackendErrors(error)
  })
}

export function handleBackendErrors(error) {
  if (!error.response) throw Error('Unknown network error')

  if (isUnauthorized(error)) {
    // We just logout when the unauthorized message comes from sennder's backend
    // (so we avoid logouts third-party 401's)
    if (isUnauthorizedBySennder(error)) logout()

    throw Error('Unauthorized user')
  }
  throw new Error(JSON.stringify(error.response.data))
}

function isUnauthorized(error) {
  return error.response.status === 401
}

function isUnauthorizedBySennder(error) {
  return error.config && error.config.url.includes(BACKEND_URL)
}

function logout() {
  removeCookie('auth_key')
  router.push('/login')
}

function getCookies() {
  return document.cookie.split('; ').reduce((newCookies, cookie) => {
    const [attrName, value] = cookie.split('=')
    newCookies[attrName] = value
    return newCookies
  }, {})
}

function getCookie(name) {
  return getCookies()[name]
}

function setCookie(name, value, maxAge) {
  if (maxAge) {
    document.cookie = `${name}=${value};path=/;max-age=${maxAge}`
  } else {
    document.cookie = `${name}=${value};path=/`
  }
}

function removeCookie(name) {
  setCookie(name, '')
}
